import React from 'react';
import SectionContainer from 'components/Containers/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { Image } from 'components/Image/Image';
import './BuyCarTipModuleView.scss';

const BuyCarTipsModuleView = props => {
  const steps1 = props?.config?.auto_loan?.buy_a_car?.steps.step1 || [];
  const steps2 = props?.config?.auto_loan?.buy_a_car?.steps.step2 || [];

  return (
    <SectionContainer className="padB40 m-padB24 buyCarTipContainer">
      <Row>
        <FlexContainer className="flex-column">
          <FlexContainer className="items-align-center">
            <Image imgClass="lightBulbIcon bgImageWH44" />
            <Label type="H4" typeHeader="h3" className="mH5 marg0">
              {props?.config?.auto_loan?.buy_a_car?.title}
            </Label>
          </FlexContainer>
          <FlexContainer className="margT20 m-flex-column">
            <FlexContainer className="flex-column flex-1">
              {steps1.map((step, index) => (
                <Label key={index} className="Body-1 mBody-2 margT8 m-margT4">
                  <span className="Subtitle-1 margR6">{`${step.no}.`}</span>
                  <span>{step.option}</span>
                </Label>
              ))}
            </FlexContainer>
            <FlexContainer className="flex-column flex-1">
              {steps2.map((step, index) => (
                <Label key={index} className="Body-1 mBody-2 margT8 m-margT4">
                  <span className="Subtitle-1 margR6">{`${step.no}.`}</span>
                  <span>{step.option}</span>
                </Label>
              ))}
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>
      </Row>
    </SectionContainer>
  );
};

export default BuyCarTipsModuleView;
